<cft-dialog *transloco="let t" [title]="t('calculators.close.title')">
  <cft-dialog-content>
    <div>{{ t('calculators.close.description') }}</div>
    <div class="mt-xl flex">
      <div>
        <fa-icon [icon]="phoneIcon"></fa-icon>
      </div>
      <div class="ml-sm text-base">
        <div class="font-bold">{{ t('calculators.close.contact.title') }}</div>
        <div>
          <a [href]="t('shared.support.email') | bgoMailTo">{{ t('shared.support.email') }}</a>
        </div>
        <div>
          <a [href]="t('shared.support.phone') | bgoTel">{{ t('shared.support.phone') }}</a>
          ({{ t('shared.support.operatingHours') }})
        </div>
      </div>
    </div>
  </cft-dialog-content>
  <cft-dialog-footer>
    <button type="button" class="btn-sm btn btn-hero" (click)="close()">
      {{ exitButtonText }}
    </button>
  </cft-dialog-footer>
</cft-dialog>
